import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ApiPurpleFitCompleteRegistrationRequest, ApiPurpleFitRegisterRequest, ApiPurpleFitUpdateUserInfoRequest, PRPVUserFull } from '../sdk';
import { LayoutService } from '../../app/layout/layout.service';
import { environment } from '../../environments/default/environment';
import { PurpleApiTokenService } from '@purple-lib/purple-api-token';
import { PurpleTranslationService } from '@purple-lib/purple-translations-core';
import { PurpleUserService } from '@purple-lib/purple-users-core';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuard  { 
  constructor(private router: Router, private userSvc: PurpleUserService<PRPVUserFull, ApiPurpleFitRegisterRequest, ApiPurpleFitCompleteRegistrationRequest, ApiPurpleFitUpdateUserInfoRequest>, private tsvc: PurpleTranslationService, private tokenSvc: PurpleApiTokenService, private layoutSvc: LayoutService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const mustBeLogged: boolean = route.data['mustBeLogged'];

    try { 
      const allTokens = this.tokenSvc.getAllTokens();      
      if (this.userSvc.checkTokensValidity(allTokens)) {
        this.userSvc.checkUser(allTokens.find(f=> f.serviceType === "userToken")!.tokenValue!);

        if (mustBeLogged) {
          this.layoutSvc.setCurrentActiveMenu(true)
          return true;
        } else {
          this.layoutSvc.setCurrentActiveMenu(true)
          return this.router.createUrlTree(['/' + this.tsvc.currentLanguage(), environment.CLIENT_ROUTE, 'home'], {queryParams: {redirectUrl: state.url}});
        }
        
      }else{
        if (mustBeLogged) {
          this.layoutSvc.setCurrentActiveMenu(false);
          this.userSvc.logout();
          return this.router.navigate([this.tsvc.currentLanguage(), 'login'], {queryParams: {redirectUrl: state.url}});
        } else {
          this.layoutSvc.setCurrentActiveMenu(false)
          return true;
        }
      }

    } catch (error) {
      if (mustBeLogged) {
        this.layoutSvc.setCurrentActiveMenu(false)
        this.userSvc.logout();
        return this.router.navigate([this.tsvc.currentLanguage(), 'login'], {queryParams: {redirectUrl: state.url}});
      } else {
        this.layoutSvc.setCurrentActiveMenu(false)
        return true;
      }
    }
  }
}
